import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Report, RowActions } from 'src/app/dashboard/admin/report/report';
import { BaseLoggedInGetService } from 'src/app/shared/services/base-logged-in-get.service';
import { BaseLoggedInPostService } from 'src/app/shared/services/base-logged-in-post.service';
import Swal from 'sweetalert2';
import { BillCategoryReportService } from './bill-category/services/bill-category-report.service';



@Component({
  template: '',
})
export  class BaseBillReportComponent implements OnInit {


  data;
  totalRecords: number;
  fetchRequestedReportService: BillCategoryReportService;
  deleteRowService
  requestBody: Report = {};
  loading = false;
  displayMessage = '';
  actions: RowActions[] = [
    {
      actionName: 'delete',
      actionType: 'icon',
      iconClass: 'fa fa-trash',
    },
    {
      actionName: 'edit',
      actionType: 'icon',
      iconClass: 'fa fa-edit',
    },
  ];
  constructor(
    private fetchService: BaseLoggedInPostService,
    private deleteReportRowService: BaseLoggedInPostService,
    private route: Router,
    private cdr: ChangeDetectorRef,
    private activeRoute: ActivatedRoute
  ) {
    this.fetchRequestedReportService = fetchService;
    this.deleteRowService = deleteReportRowService;
    this.fetchRequestedReportService.deactivateLoader();
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
  }

  ngOnInit() {
    this.fetchRequestedReportService.activateLoader();
    this.updateTable();
  }
  async updateTable() {
    this.fetchRequestedReportService.activateLoader();
    this.fetchRequestedReportService.setParams(this.requestBody);
    let responseData = await this.fetchRequestedReportService.make();
    this.totalRecords = responseData.totalNumberOfRows;
    this.data = responseData.result;
    this.cdr.detectChanges();
  }
   setDisplayMessage(message: string) {
    this.displayMessage = message;
  }

  actionEmiter(event) {
    console.log(event);
    switch (event.action) {
      case 'delete':
        this.deleteRequestedRow(event.key.ID);
        break;

      case 'edit':
        this.editRequested(event.key.ID, event.key.serviceId);
        break;
      default:
        break;
    }
  }

  async deleteRequestedRow(id: number) {
    Swal.fire({
      title: `Are you sure you want to delete this ${this.displayMessage}?`,
      text: '',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then(async (result) => {
      if (result.value) {
        this.deleteRowService.setParams({ ID: id });
        let responseData = await this.deleteRowService.make();
        if (responseData.success) {
          await this.updateTable();
        }
      }
    });
  }

  async editRequested(id: number, serviceId: number) {
    this.route.navigate([`edit/${id}/service/${serviceId}`], { relativeTo: this.activeRoute });
  }
  async filter(event: any) {
    if (event && Object.keys(event).length) {
      this.requestBody.filterOptions = event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.fetchRequestedReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize
    };
    this.updateTable();
    this.fetchRequestedReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.fetchRequestedReportService.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === "") {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.fetchRequestedReportService.loader().subscribe((val: any) => (this.loading = val));
  }
}
